// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"1591f120","596":"936ce9a7","697":"59bc80e4","773":"696963e0"}[chunkId] + ".chunk.js";
};